export default __webpack_public_path__ + "static/si-summit-logo-9a58b620fbf01081079271a6ac695450.png";